import { rootApi } from "../../api/rootApi";

export const supplyBeamConfigAdminApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    // List all configured stages for a tenant (from Main SaaS DB)
    adminGetSupplyBeamConfigList: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/supply-beam-config/list?tenant_id=${params.tenant_id}${params.query ? `&${params.query}` : ""}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
      }),
    }),

    // Create a new location type/stage config in Main SaaS DB
    adminCreateSupplyBeamConfig: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/supply-beam-config/add",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
        body: { ...params.body, tenant_id: params.tenant_id },
      }),
    }),

    // Get config details by id
    adminGetSupplyBeamConfigById: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/supply-beam-config/details/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
      }),
    }),

    // Update config by id
    adminUpdateSupplyBeamConfig: builder.mutation({
      query: (params) => ({
        method: "PUT",
        url: `/admin/supply-beam-config/update/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
        body: { ...params.body, tenant_id: params.tenant_id },
      }),
    }),

    // Toggle status (1/0)
    adminToggleSupplyBeamConfigStatus: builder.mutation({
      query: (params) => ({
        method: "PATCH",
        url: `/admin/supply-beam-config/toggle-status/${params.id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
        body: { status: params.status },
      }),
    }),

    // Reorder stages in Main SaaS DB
    adminReorderSupplyBeamConfig: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/supply-beam-config/reorder",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
        body: { items: params.items, tenant_id: params.tenant_id },
      }),
    }),

    // Get Theme Configuration for tenant (from Main SaaS DB)
    adminGetSupplyBeamTheme: builder.mutation({
      query: (params) => ({
        method: "GET",
        url: `/admin/supply-beam-config/theme?tenant_id=${params.tenant_id}`,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
      }),
    }),

    // Save/Update Theme Configuration for tenant (in Main SaaS DB)
    adminSaveSupplyBeamTheme: builder.mutation({
      query: (params) => ({
        method: "POST",
        url: "/admin/supply-beam-config/theme",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + params.token,
          slug: String(params.tenant_id),
        },
        body: { theme: params.theme, tenant_id: params.tenant_id },
      }),
    }),
  }),
});

export const {
  useAdminGetSupplyBeamConfigListMutation,
  useAdminCreateSupplyBeamConfigMutation,
  useAdminGetSupplyBeamConfigByIdMutation,
  useAdminUpdateSupplyBeamConfigMutation,
  useAdminToggleSupplyBeamConfigStatusMutation,
  useAdminReorderSupplyBeamConfigMutation,
  useAdminGetSupplyBeamThemeMutation,
  useAdminSaveSupplyBeamThemeMutation,
} = supplyBeamConfigAdminApi;
